import { render, staticRenderFns } from "./ProfileSearch.vue?vue&type=template&id=52762300&scoped=true&"
import script from "./ProfileSearch.vue?vue&type=script&lang=js&"
export * from "./ProfileSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSearch.vue?vue&type=style&index=0&id=52762300&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52762300",
  null
  
)

export default component.exports